<template>
    <span class="flex items-center gap-1.5">
        <font-awesome-icon widthAuto :icon="currentContext.icon" :class="currentContext.color"></font-awesome-icon>
        <span
            class="overflow-hidden max-w-24 md:max-w-36"
            :class="{
                'mask-r-from-70% mask-r-to-100%': (currentGroup || currentOrgUnit) && currentContext.name.length > 20,
            }"
        >
            {{ currentContext.name }}
        </span>
        <span class="flex items-center gap-0.5 text-white opacity-30">
            <template v-if="usesCommandKey">
                <font-awesome-icon widthAuto :icon="faCommand"></font-awesome-icon>
            </template>
            <template v-else> Ctrl </template>
            G
        </span>
    </span>
</template>

<script setup>
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBuildingFlag, faCommand, faCrown, faGrid2Plus } from '@fortawesome/pro-solid-svg-icons';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const { currentGroup, currentOrgUnit } = useCurrentGroup();

const usesCommandKey = /iPad|iPhone|Mac OS/.test(navigator.userAgent);

const currentContext = computed(() => {
    if (currentOrgUnit.value) {
        return { name: currentOrgUnit.value.name, icon: faBuildingFlag, color: 'text-white' };
    }
    if (currentGroup.value) {
        return { name: currentGroup.value.name, icon: faGrid2Plus, color: 'text-white' };
    }
    return { name: 'Corporate', icon: faCrown, color: 'text-amber-400' };
});

defineExpose({ currentContext });
</script>
